import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const inactivePartnerApi = createAsyncThunk(
  "aadhar",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.name = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/inactive_partner_data", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      return response.data;
    }
  }
);

const inactivePartnerSlice = createSlice({
  name: "inactivePartner",
  initialState: {
    inactivePartner: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(inactivePartnerApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(inactivePartnerApi.fulfilled, (state, action) => {
        state.inactivePartner = action.payload;
        state.loading = false;
      })
      .addCase(inactivePartnerApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default inactivePartnerSlice.reducer;
